import { Switch as Switch$ } from 'formik-antd/lib/switch';
import React from 'react';
export function Switch({
  name,
  id,
  ...props
}: React.ComponentProps<typeof Switch$>) {
  return <Switch$ name={name} id={id ?? name} {...props} />;
}
